import { Box, Typography } from "@mui/material";

const FinancialDefinition = () => {
  return (
    <Box m="20px">
      <Typography variant="h2" fontWeight="bold">
        Financial Definition
      </Typography>
    </Box>
  );
};

export default FinancialDefinition;